import React from "react";
import { Grid } from "@material-ui/core";
import ButtonCustom from "components/buttonCustom";
import useSpecializations from "./useSpecializations";
import { Subtitle, Text, GroupCouses, GroupField, Input, BoxError, Icon } from "../../../Styled";
import { WorkWithUSAddCourse } from "components/WorkWithUSAddCourse";
import { WorkWithUSAddProfessionExperience } from "components/WorkWithUSAddProfessionExperience";
import ItemExperience from "components/itemExperience";
import { InputCheckbox } from "components/form";
import { DatePicker } from "components/DatePicker";

import { Modal, ModalBody, ModalTitle } from "./Styled";

import {
  InputUploadDoc
} from "../../../../../screens/workWithUs/Styled";

const Specializations = () => {
    const {
        isVigilant,
        dataFields,
        courseType,
        showAddCourse,
        showAddProfessionExperience,
        errors,
        validateCnv,
        lastRecycle,
        openModal,
        translate,
        handleSave,
        handleHideAddCourse,
        handleShowProfessionExperience,
        handleProfessionExperienceSave,
        handleProfessionExperienceHide,
        handleRemoveExperience,
        handleChangeFile,
        handleRemoveFile,
        handleChangeText,
        handleChangeDate,
        setValidateCnv,
        setLastRecycle,
        setOpenModal,
        handleChangeCheckboxPrimeiraVia,
        handleChangeCheckbox,
        handleCloseModal,
    } = useSpecializations();

  return (
    <React.Fragment>
        {isVigilant && (
            <Modal open={openModal}>
                <ModalTitle>Primeira via CNV</ModalTitle>

                <ModalBody>
                    Ao selecionar primeira via desconsidere o campo CNV e Data de válidade.
                </ModalBody>

                <ButtonCustom className="btn-green" onClick={handleCloseModal}>
                Entendi
                </ButtonCustom>
            </Modal>
        )}
        {isVigilant && (
            <Subtitle>
                {translate("workWithUs.form.step5.recyclingCertificates")}
            </Subtitle>
        )}
        {showAddCourse && (
            <WorkWithUSAddCourse courseType={courseType} handleSave={handleSave} handleHideCourse={handleHideAddCourse} />
        )}

        {!showAddCourse && (
            <GroupCouses>
                <Grid container spacing={2}>
                    {isVigilant && (
                        <>
                            <Grid item xs={12} md={12} >
                                <Text bold="bold" style={{marginBottom: 0}}>
                                    {translate("workWithUs.form.step5.attachmentCnv")}
                                </Text>
                            </Grid>
                            <Grid item xs={12} lg={4} xl={4}>
                                <GroupField>
                                    <DatePicker
                                        label={translate("workWithUs.form.step5.validateDate") + " (*)"}
                                        value={validateCnv}
                                        onChange={(newValue) =>
                                            handleChangeDate(
                                                newValue,
                                                "specializations",
                                                "validate_cnv",
                                                setValidateCnv(newValue)
                                            )
                                        }
                                        error={errors?.specializations?.validate_cnv}
                                        />
                                </GroupField>
                            </Grid>
                            <Grid item xs={12} md={12} lg={5} xl={5}>
                                <GroupField>
                                    <Input
                                        fullWidth
                                        transparent="true"
                                        id="cnv"
                                        name="cnv"
                                        label={
                                            dataFields?.specializations?.first_copy_cnv
                                            ? translate("workWithUs.form.step3.cnv")
                                            : translate("workWithUs.form.step3.cnv") + " (*)"
                                        }
                                        autoComplete="off"
                                        value={dataFields?.specializations?.cnv || ""}
                                        onChange={(props) =>
                                            handleChangeText(props, "specializations")
                                        }
                                        error={errors?.specializations?.cnv}
                                    />
                                </GroupField>
                            </Grid>
                            <Grid item xs={12} md={12} lg={3} xl={3}>
                                <GroupField>
                                    <InputCheckbox
                                        label="Primeira via?"
                                        name="first_copy_cnv"
                                        marginTop={22}
                                        checked={!!dataFields?.specializations?.first_copy_cnv}
                                        onChange={(props) =>
                                            handleChangeCheckboxPrimeiraVia(
                                            props,
                                            "specializations",
                                            setOpenModal(props.target.checked)
                                        )}
                                    />
                                </GroupField>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <GroupField>
                                    <InputUploadDoc
                                        icon="icon-document-edit"
                                        name="cnv_anexo"
                                        label={translate("workWithUs.form.step5.attachmentCnv")}
                                        file={dataFields?.cnv_anexo?.name}
                                        onChange={handleChangeFile}
                                        onRemove={() => handleRemoveFile("cnv_anexo")}
                                        error={errors.specializations?.cnv_anexo}
                                    />
                                </GroupField>
                            </Grid>
                        </>
                    )}

                    {isVigilant && (
                        <>
                            {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                                <GroupField>
                                    <Text bold="bold">
                                        {translate("workWithUs.form.step5.lastRecycle")}
                                    </Text>
                                    {dataFields?.lastRecycle?.map((item, index) => (
                                        <ItemCourse
                                            key={index}
                                            onRemove={() =>
                                                handleRemoveCourse("lastRecycle", item)
                                            }
                                        >
                                            {++index}º Curso
                                        </ItemCourse>
                                    ))}
                                    <GroupButton>
                                        <ButtonCustom
                                            color="default"
                                            type="button"
                                            size="large"
                                            className={errors.specializations?.lastRecycle ? "btn-cancel" : "btn-blue"}
                                            startIcon={<Icon className="icon icon-plus" />}
                                            onClick={() => handleShowAddCourse("lastRecycle")}
                                            fullWidth
                                        >
                                            {translate("workWithUs.form.step5.addCourse")}
                                        </ButtonCustom>
                                    </GroupButton>
                                </GroupField>
                            </Grid> */}
                            <Grid item xs={12} lg={12} xl={12}>
                                <Subtitle style={{marginTop: '20px', marginBottom: 0}}>
                                    {translate(
                                        "workWithUs.form.step5.lastRecycle"
                                    )}
                                </Subtitle>
                            </Grid>
                            <Grid item xs={12} lg={4} xl={4}>
                                <GroupField>
                                    <DatePicker
                                        label={translate("workWithUs.form.step5.dateLastRecycle") + " (*)"}
                                        value={lastRecycle}
                                        onChange={(newValue) =>
                                            handleChangeDate(
                                                newValue,
                                                "specializations",
                                                "date_lastRecycle",
                                                setLastRecycle(newValue)
                                            )
                                        }
                                        error={errors?.specializations?.date_lastRecycle}
                                        />
                                </GroupField>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <GroupField>
                                    <InputUploadDoc
                                        icon="icon-document-edit"
                                        name="lastRecycle_anexo"
                                        label={translate("workWithUs.form.step5.attachmentDoc")}
                                        file={dataFields?.lastRecycle_anexo?.name}
                                        onChange={handleChangeFile}
                                        onRemove={() => handleRemoveFile("lastRecycle_anexo")}
                                    />
                                </GroupField>
                            </Grid>

                            {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                                <GroupField>
                                    {isVigilant && (
                                        <Text bold="bold">
                                            {translate("workWithUs.form.step5.extensionCourses")}
                                        </Text>
                                    )}
                                    {dataFields?.extensionCourse?.map((item, index) => (
                                        <ItemCourse
                                            key={index}
                                            onRemove={() =>
                                            handleRemoveCourse("extensionCourse", item.name)
                                            }
                                        >
                                            {item.name}
                                        </ItemCourse>
                                    ))}
                                    <GroupButton>
                                        <ButtonCustom
                                            color="default"
                                            type="button"
                                            size="large"
                                            className="btn-blue"
                                            startIcon={<Icon className="icon icon-plus" />}
                                            onClick={() => handleShowAddCourse("extensionCourse")}
                                            fullWidth
                                            >
                                            {translate("workWithUs.form.step5.addCourse")}
                                        </ButtonCustom>
                                    </GroupButton>
                                </GroupField>
                            </Grid> */}
                        </>
                    )}
                </Grid>
            </GroupCouses>
        )}

        <br />
        <br />

        <Subtitle>
            {translate(
                "workWithUs.form.step6.professionalExperience"
            )}
        </Subtitle>

         <GroupField>
            <InputCheckbox
                label="É o seu primeiro emprego?"
                name="firstJob"
                checked={!!dataFields?.firstJob}
                onChange={(props) =>
                    handleChangeCheckbox(props)
                }
            />
        </GroupField>

        {!!errors?.specializations?.experience && (
            <BoxError>
                Você precisa informar pelo menos uma experiência de trabalho ou anexar um currículo.
            </BoxError>
        )}

        {!dataFields?.firstJob && (
        <>
            {showAddProfessionExperience && (
                <WorkWithUSAddProfessionExperience
                    handleSave={handleProfessionExperienceSave}
                    handleHideCourse={handleProfessionExperienceHide}
                />
            )}

            {!showAddProfessionExperience && (
                <GroupCouses>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <GroupField>
                                {dataFields?.experience?.map((item, index) => (
                                    <ItemExperience
                                        key={index}
                                        company={item.company}
                                        office={item.office}
                                        startDate={item.startDate}
                                        endDate={item.endDate}
                                        onRemove={() =>
                                            handleRemoveExperience(
                                                "experience",
                                                item
                                            )
                                        }
                                    />
                                ))}
                                <ButtonCustom
                                    color="default"
                                    type="button"
                                    size="large"
                                    className="btn-blue"
                                    startIcon={
                                        <Icon className="icon icon-plus" />
                                    }
                                    onClick={() =>
                                        handleShowProfessionExperience()
                                    }
                                    fullWidth
                                >
                                    {translate(
                                        "workWithUs.form.step6.addExperience"
                                    )}
                                </ButtonCustom>
                            </GroupField>
                        </Grid>
                    </Grid>
                </GroupCouses>
            )}
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <GroupField>
                        <InputUploadDoc
                            className="btn-blue"
                            icon="icon-document-edit"
                            name="curriculum"
                            label={translate(
                                "workWithUs.form.step6.attachResume"
                            )}
                            file={dataFields?.curriculum?.name}
                            onChange={handleChangeFile}
                            onRemove={() =>
                                handleRemoveFile("curriculum")
                            }
                        />
                    </GroupField>
                </Grid>
            </Grid>
        </>
        )}
    </React.Fragment>
  );
};

export default Specializations;
